import type { IThunderboltComponentModel } from '@wix/editor-elements-types';
import { Hosts } from '@wix/editor-elements-conventions';
import {
  IComponentLoader,
  IComponentRegistry,
  IRegistryAPI,
  IRegistryRuntime,
} from '../registry.types';
import { createEntry } from './createEntry/createEntry';

export type IThunderboltRegistryAPI = IRegistryAPI<IThunderboltComponentModel>;

export type IThunderboltComponentLoader =
  IComponentLoader<IThunderboltComponentModel>;

export type IThunderboltRegistry =
  IComponentRegistry<IThunderboltComponentModel>;

export const registry: IThunderboltRegistry = createEntry({
  host: Hosts.Thunderbolt,
  libraryAssetsPatterns: [
    {
      pattern: /\.metadata\.json$/,
      type: 'stylable-metadata',
    },
  ],
});

export { IThunderboltComponentModel };

export type IThunderboltRegistryRuntime = IRegistryRuntime;

export * from '../toolbox';
export * from '../registry.types';

export default registry;
